// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Supported declared date/datetime value formats a DAE may set in a Date/Datetime variable's data_format. Canonical source: backend/lambda/common/variable_format.py (DATE_FORMATS).
 * @export
 */
export const DateFormat = {
    YyyyMmDd: 'YYYY-MM-DD',
    MmDdYyyy: 'MM/DD/YYYY',
    DdMmYyyy: 'DD/MM/YYYY',
    DdMmYyyy2: 'DD.MM.YYYY',
    DdMonYyyy: 'DD-MON-YYYY',
    YyyyMmDdthhMm: 'YYYY-MM-DDTHH:MM',
    YyyyMmDdthhMmSs: 'YYYY-MM-DDTHH:MM:SS',
    YyyymmddthhMm: 'YYYYMMDDTHH:MM'
} as const;
export type DateFormat = typeof DateFormat[keyof typeof DateFormat];


export function instanceOfDateFormat(value: any): boolean {
    for (const key in DateFormat) {
        if (Object.prototype.hasOwnProperty.call(DateFormat, key)) {
            if (DateFormat[key as keyof typeof DateFormat] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DateFormatFromJSON(json: any): DateFormat {
    return DateFormatFromJSONTyped(json, false);
}

export function DateFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): DateFormat {
    return json as DateFormat;
}

export function DateFormatToJSON(value?: DateFormat | null): any {
    return value as any;
}

export function DateFormatToJSONTyped(value: any, ignoreDiscriminator: boolean): DateFormat {
    return value as DateFormat;
}
